<label class="full-width" for="Controller">Controller</label>
<select class="full-width" [formControl]="formControl">
  @for (controller of controllerStrings; track controller) {
    <option [value]="controller">{{controller}}</option>
  }
</select>
<ng-container #portal></ng-container>